module.exports = __webpack_public_path__ + "img/error-solid.4324bb9c.svg";